import { render, staticRenderFns } from "./Service_center.vue?vue&type=template&id=935408b2&scoped=true"
import script from "./Service_center.vue?vue&type=script&lang=js"
export * from "./Service_center.vue?vue&type=script&lang=js"
import style0 from "./Service_center.vue?vue&type=style&index=0&id=935408b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "935408b2",
  null
  
)

export default component.exports